import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import AdminDashboard from './AdminDashboard';
import ProviderDashboard from './ProviderDashboard';
import ClientDashboard from './ClientDashboard';
import ProviderLayoutRuntime from '../components/ProviderLayoutRuntime';

const DashboardRouter = () => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-white text-lg">Cargando...</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  switch (user.role) {
    case 'admin':
      return <AdminDashboard />;
    case 'provider':
      return user.provider_type === 'taxi' ? (
        <ProviderLayoutRuntime>
          <ProviderDashboard />
        </ProviderLayoutRuntime>
      ) : <ProviderDashboard />;
    case 'client':
      return <ClientDashboard />;
    default:
      return (
        <div className="min-h-screen flex items-center justify-center">
          <div className="text-white">Rol no reconocido</div>
        </div>
      );
  }
};

export default DashboardRouter;
